import { r as e } from "./register-BHPprNTQ.js";
import { I as c } from "./register-BHPprNTQ.js";
const o = {
  xxs: "icon--xxs",
  xs: "icon--xs",
  sm: "icon--sm",
  md: "icon--md"
}, l = [
  "accessibility-easy-language",
  "accessibility-physical-impairment",
  "accessibility-sign-language",
  "alert-circle",
  "alert-triangle",
  "archive",
  "arrow-left",
  "arrow-right",
  "bag",
  "bell-filled",
  "bell",
  "boat",
  "bookmark-filled",
  "bookmark",
  "box-send",
  "building-arch",
  "building-community",
  "building-factory",
  "building-government",
  "building-monument",
  "building-skyscraper",
  "building",
  "calendar-plus",
  "calendar",
  "car",
  "cart",
  "cash",
  "check-circle",
  "check-interactive",
  "check",
  "chevron-double-left",
  "chevron-double-right",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "clipboard-money",
  "clock",
  "close-interactive",
  "close",
  "cloud-off",
  "cloud",
  "coins",
  "communication",
  "contacts",
  "copy",
  "copyright",
  "couch",
  "crown",
  "dots-horizontal",
  "dots-vertical",
  "download",
  "edit-off",
  "edit",
  "education",
  "euro",
  "eye-closed",
  "eye-crossed-out",
  "eye",
  "file-certified",
  "file-chart",
  "file-download",
  "file-error",
  "file-image",
  "file-invoice",
  "file-more",
  "file-music",
  "file-stats",
  "file-text",
  "file-upload",
  "file-video",
  "file",
  "filter-filled",
  "filter-plus",
  "filter-reset",
  "filter",
  "forms",
  "globe-dollar",
  "globe",
  "grave",
  "grip-horizontal",
  "hamburger",
  "health",
  "home",
  "hourglass",
  "id-card",
  "info-circle",
  "info-interactive-filled",
  "info-interactive",
  "key-crossed-out",
  "key",
  "layout-grid",
  "layout-list",
  "layout-three-columns",
  "layout-two-columns",
  "lifebuoy",
  "link-crossed-out",
  "link-external",
  "link",
  "load-more",
  "loader-quarter",
  "loader",
  "location-1-filled",
  "location-1",
  "location-2",
  "lock-closed",
  "lock-open",
  "logout",
  "loudspeaker",
  "mail-check",
  "mail-forward",
  "mail-open",
  "mail-x",
  "mail",
  "map-location",
  "map",
  "message",
  "microscope",
  "minus-interactive",
  "minus",
  "pause-interactive",
  "phone",
  "play-interactive",
  "plus-interactive",
  "plus",
  "printer",
  "question-circle",
  "question-interactive-filled",
  "question-interactive",
  "receipt",
  "refresh",
  "register",
  "reload",
  "rocket",
  "save",
  "scroll",
  "search-check",
  "search-x",
  "search",
  "settings-filled",
  "settings",
  "share-1",
  "share-2",
  "shield-filled",
  "shield-half",
  "shield-question",
  "shield-third",
  "shield",
  "sort-alphabet-down",
  "sort-alphabet-up",
  "sort-down",
  "sort-numbers-down",
  "sort-numbers-up",
  "sort-up",
  "sort",
  "stack",
  "star-filled",
  "star",
  "statistic",
  "stop",
  "stroller",
  "support",
  "thumbs-down",
  "thumbs-up",
  "trash",
  "tree",
  "trolley",
  "undo",
  "upload",
  "user-check",
  "user-circle",
  "user-group",
  "user-x",
  "user",
  "users"
];
e();
export {
  l as ICON_NAMES,
  o as ICON_SIZES,
  c as Icon
};
